module.exports = __webpack_public_path__ + "img/a11y-stability-1_jp.abeee40.jpg";